import React from 'react';
import { useNavigate } from 'react-router-dom';
import Image from '../../../components/AppImage';
import Icon from '../../../components/AppIcon';
import Button from '../../../components/ui/Button';

const FavoriteTrailerCard = ({ trailer }) => {
  const navigate = useNavigate();

  const renderRatingStars = (rating) => {
    return (
      <div className="flex items-center space-x-1">
        {[1, 2, 3, 4, 5]?.map((star) => (
          <Icon
            key={star}
            name="Star"
            size={14}
            strokeWidth={2}
            className={star <= rating ? 'text-accent fill-accent' : 'text-muted-foreground'}
          />
        ))}
      </div>
    );
  };

  return (
    <div className="bg-card rounded-lg shadow-elevation-2 overflow-hidden hover:shadow-elevation-3 transition-smooth h-full flex flex-col">
      <div className="relative">
        <Image
          src={trailer?.image}
          alt={trailer?.imageAlt}
          className="w-full h-48 object-cover"
        />
        <button
          className="absolute top-3 right-3 w-10 h-10 bg-card rounded-full flex items-center justify-center shadow-elevation-2 hover:shadow-elevation-3 transition-smooth"
          aria-label="Remove from favorites"
        >
          <Icon name="Heart" size={20} strokeWidth={2} className="text-error fill-error" />
        </button>
        {!trailer?.available && (
          <div className="absolute bottom-3 left-3 px-3 py-1 bg-error/90 text-error-foreground rounded-full text-xs font-medium">
            Currently Unavailable
          </div>
        )}
        {trailer?.available && (
          <div className="absolute bottom-3 left-3 px-3 py-1 bg-success/90 text-success-foreground rounded-full text-xs font-medium flex items-center space-x-1">
            <Icon name="CheckCircle" size={12} strokeWidth={2} />
            <span>Available</span>
          </div>
        )}
      </div>
      
      <div className="p-4 flex-1 flex flex-col">
        <h3 className="font-heading text-lg font-semibold text-foreground mb-2">
          {trailer?.name}
        </h3>
        
        <div className="flex items-center space-x-2 mb-3">
          {renderRatingStars(trailer?.rating)}
          <span className="font-body text-sm text-foreground font-medium">
            {trailer?.rating?.toFixed(1)}
          </span>
        </div>

        <div className="flex items-center space-x-2 text-sm text-muted-foreground mb-4">
          <Icon name="MapPin" size={14} strokeWidth={2} />
          <span className="font-body">{trailer?.location}</span>
        </div>

        <div className="mt-auto">
          <div className="flex items-center justify-between mb-3">
            <div>
              <p className="font-heading text-2xl font-bold text-primary">${trailer?.pricePerDay}</p>
              <p className="font-caption text-xs text-muted-foreground">per day</p>
            </div>
          </div>

          <Button
            variant="default"
            size="sm"
            iconName="ArrowRight"
            iconPosition="right"
            onClick={() => navigate('/trailer-detail')}
            className="w-full"
            disabled={!trailer?.available}
          >
            {trailer?.available ? 'View Details' : 'Notify When Available'}
          </Button>
        </div>
      </div>
    </div>
  );
};

export default FavoriteTrailerCard;